import React, { Component } from "react";
import { callApi } from "../../utils/api";
import "../block-download/block_download.css";
import { Link } from "react-router-dom";
import {
    ToastsStore,
    ToastsContainer,
    ToastsContainerPosition,
} from "react-toasts";
import moment from "moment";
import ExcelJS from "exceljs";
import { ADMIN_ROLE } from "../../utils/role";
import { hasPageAccess } from "../../utils/pagePermissionService";

declare var $: any;

interface AllProps {
    history: any;
}

interface PdfItem {
    id: string;
    name: string;
    status: string; // "0" or "1"
    quality: string; // "", "Original", "High", "Medium", "Low"
    type: string;
}

interface PdfData {
    "Pdf document": PdfItem[];
    "Pdf Category": PdfItem[];
}

class PdfCompressManagement extends Component<AllProps> {
    state = {
        pdfDocumentItems: [] as PdfItem[],   // First table
        pdfCategoryItems: [] as PdfItem[],   // Second table
        deeds: [] as PdfItem[],   // Second table
        isLoading: false,
        outreason: "",
        selectVal: false,
        deedSearch: "",
    };

    async componentDidMount() {
        this.listDeed();
        this.fetchPdfSettings();
        this.getOutTime();
        const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
        if (!hasHide) {
            this.ouTime();
        }
    }

    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    };
    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");

        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    };
    getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime));
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        } else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
    };
    ouTime = () => {
        const getfileId: any = localStorage.getItem("currentfileId");
        console.log("54", JSON.parse(getfileId));
        console.log("32", getfileId);
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    };
    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        console.log("70", intime);
        const outtime: any = localStorage.getItem("outtimeGet");
        console.log("73", outtime);
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(
            moment(intime, "HH:mm"),
            "seconds"
        );
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason == "") {
            this.setState({ selectVal: true });
        } else {
            let obj = {
                file_id: JSON.parse(fileid1),
                user_id: JSON.parse(userid1),
                in_reason: JSON.parse(inreason),
                out_reason: this.state.outreason,
                intime: JSON.parse(intime),
                outtime: JSON.parse(outtime),
                insert_date: JSON.parse(outdate),
                total_seconds: secondsSpent,
                "insert_id": insertId
            };

            // console.log("72",obj);
            callApi("POST", "process_eod_insert.php", obj)
                .then((res) => res.data)
                .then((response) => {
                    console.log("76", response);
                    this.setState({ isLoading: false });
                    // localStorage.removeItem("currentfileId");
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                    localStorage.removeItem("currentfileId");
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                    ToastsStore.error("Your Reason Not Stored");
                });
        }
    };

    onchangeReason = (e: any) => {
        if (e.target.value == "Other") {
            this.setState({ in_reason: "", selectVal: false });
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        } else if (e.target.value == "select") {
            this.setState({ setResponse: false });
        } else {
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };

    onchange = (e: any) => {
        this.setState({
            [e.target.name]: e.target.value.replace(/\s+/g, " ").trim(),
            selectVal: false,
        });
    };

    listDeed = () => {
        this.setState({ isFileRefresh: false })
        callApi("GET", "deed_master_get.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                if (files && files.length > 0) {
                    files.forEach((file, index) => {
                        Object.keys(file).forEach(fileKey => {
                            file[fileKey] = !file[fileKey] ? "" : typeof file[fileKey] !== 'string' ? String(file[fileKey]) : file[fileKey];
                        })
                        file.index = index + 1;
                    })
                }
                this.setState({ deeds: files, isFileRefresh: true });
            })
            .catch(err => {
                console.log(err);
            });
    };

    fetchPdfSettings = () => {
        callApi("POST", "pdf_category.php")
            .then((res) => res.data)
            .then((response: { result: boolean; data: PdfData }) => {
                if (response.result && response.data) {
                    this.setState({
                        pdfDocumentItems: response.data["Pdf document"] || [],
                        pdfCategoryItems: response.data["Pdf Category"] || [],
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                ToastsStore.error("Failed to load PDF settings");
            });
    };

    // Toggle status for any item (used by both tables)
    handleStatusToggle = (id: string, checked: boolean) => {

        const updateList = (list: PdfItem[]) =>
            list.map((item) => {
                if (!checked) {
                    // If unchecked → update only items that have id
                    return item.id ? { ...item, status: "0" } : item;
                } else {
                    // If checked → update only matched item
                    return item.id === id ? { ...item, status: "1" } : item;
                }
            });

        this.setState((prev: any) => ({
            pdfDocumentItems: updateList(prev.pdfDocumentItems),
            // pdfCategoryItems: updateList(prev.pdfCategoryItems),
            // deeds: updateList(prev.deeds),
        }));
    };

    // Change quality for any item
    handleQualityChange = (id: string, value: string, type) => {
        const updateList = (list: PdfItem[]) =>
            list.map((item) =>
                item.id === id ? { ...item, quality: value } : item
            );

        this.setState((prev: any) => ({
            pdfDocumentItems:
                type === "global" && prev.pdfDocumentItems[0]?.id === id
                    ? updateList(prev.pdfDocumentItems)
                    : prev.pdfDocumentItems,
            pdfCategoryItems:
                type === "ec" && prev.pdfCategoryItems.some((i: PdfItem) => i.id === id)
                    ? updateList(prev.pdfCategoryItems)
                    : prev.pdfCategoryItems,
            deeds:
                type === "deed" && prev.deeds.some((i: PdfItem) => i.id === id)
                    ? updateList(prev.deeds)
                    : prev.deeds,
        }));
    };

    handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        this.setState({ isLoading: true });

        const payload = {
            pdfDocumentItems: this.state.pdfDocumentItems,
            pdfCategoryItems: this.state.pdfCategoryItems,
            deeds: this.state.deeds,
        };

        callApi("POST", "pdf_category_update.php", payload) // adjust endpoint if needed
            .then((res) => res.data)
            .then((response) => {
                if (response.success) {
                    this.fetchPdfSettings();
                    ToastsStore.success(response.message || "Settings saved successfully!");
                } else {
                    ToastsStore.error(response.message || "Failed to save");
                }
            })
            .catch((err) => {
                console.log(err);
                ToastsStore.error("Failed to save settings");
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    };

    renderQualityOptions = (item: PdfItem, type: any) => {
        const current = item.quality || "select";
        return (
            <select
                className="custom-select"
                value={current}
                onChange={(e) => this.handleQualityChange(item.id, e.target.value, type)}
            >
                <option value="select">Select Quality</option>
                <option value="Original">Original</option>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
            </select>
        );
    };


    exportMultiSheetExcel = async () => {

        const { pdfDocumentItems, deeds, pdfCategoryItems } = this.state;

        // Validate data exists
        if (
            !pdfDocumentItems?.length &&
            !deeds?.length &&
            !pdfCategoryItems?.length
        ) {
            ToastsStore.error("No data available to export");
            return;
        }

        const workbook = new ExcelJS.Workbook();

        // ---------------- SHEET 1 ----------------
        const sheet1 = workbook.addWorksheet("PDF Compression Global");
        sheet1.columns = [
            { header: "Sl.No", key: "sl", width: 10 },
            { header: "Name", key: "name", width: 30 },
            { header: "Quality", key: "quality", width: 20 },
            { header: "Status", key: "status", width: 20 },
        ];

        pdfDocumentItems.forEach((item, i) => {
            sheet1.addRow({
                sl: i + 1,
                name: item.name,
                quality: item.quality != "0" ? item.quality : "",
                status: item.status === "1" ? "Enabled" : "Disabled",
            });
        });

        // Header Styling
        sheet1.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });


        // ---------------- SHEET 2 ----------------
        const sheet2 = workbook.addWorksheet("Document Types Compression");
        sheet2.columns = [
            { header: "Sl.No", key: "sl", width: 10 },
            { header: "Category", key: "category", width: 30 },
            { header: "Quality", key: "quality", width: 20 },
        ];

        deeds.forEach((item, i) => {
            sheet2.addRow({
                sl: i + 1,
                category: item.name,
                quality: item.quality || "",
            });
        });

        sheet2.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });


        // ---------------- SHEET 3 ----------------
        const sheet3 = workbook.addWorksheet("Ec Category Compression");
        sheet3.columns = [
            { header: "Sl.No", key: "sl", width: 10 },
            { header: "Category", key: "category", width: 30 },
            { header: "Quality", key: "quality", width: 20 },
        ];

        pdfCategoryItems.forEach((item, i) => {
            sheet3.addRow({
                sl: i + 1,
                category: item.name,
                quality: item.quality || "",
            });
        });

        sheet3.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });


        // ---------------- DOWNLOAD FILE ----------------

        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(
            currentDate.getMonth() + 1
        ).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `PDF_Settings_${formattedDate}.xlsx`;
        link.click();
        URL.revokeObjectURL(link.href);
    };


    render() {
        const { pdfDocumentItems, pdfCategoryItems, deeds, isLoading } = this.state;

        return (
            <section className="pcoded-main-container">
                <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />

                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="file-status-header">
                                                        PDF Compression Enable & Disable
                                                    </h5>
                                                </div>

                                                <div className="card-body">
                                                    <form onSubmit={this.handleSubmit}>
                                                        {/* Download Excel — top-left of content area */}
                                                        <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                                            <button
                                                                type="button"
                                                                className="btn btn-success"
                                                                onClick={this.exportMultiSheetExcel}
                                                            >
                                                                Download Excel
                                                            </button>
                                                        </div>
                                                        {/* Save & Back Buttons */}
                                                        <div className="file-search-button formbtn" style={{ marginTop: "0%" }}>
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary"
                                                                disabled={isLoading}
                                                            >
                                                                {isLoading ? "Saving..." : "Save"}
                                                            </button>
                                                            <Link to={"/dashboard"} className="btn btn-icon btn-primary" style={{ width: "6%", marginLeft: "10px" }}>
                                                                Back
                                                            </Link>
                                                        </div>

                                                        {/* TABLE 1: Pdf document (Global) */}
                                                        <div className="sticky-table-container" style={{ marginTop: "20px", height: 'auto' }}>
                                                            <table className="table">
                                                                <thead className="sticky-table-header">
                                                                    <tr>
                                                                        <th scope="col">Sl.No</th>
                                                                        <th scope="col">Name</th>
                                                                        <th scope="col">Quality</th>
                                                                        <th scope="col head-left">Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {pdfDocumentItems.map((item, index) => (
                                                                        <tr key={item.id}>
                                                                            <td className="indexInput text-center">{index + 1}</td>
                                                                            <td className="indexInput text-center">{item.name}</td>
                                                                            <td>{item.name == 'Pdf Compression While Uploading Document' ? this.renderQualityOptions(item, "global") : ""}</td>
                                                                            <td className="table-body-align">
                                                                                <label className="switch" style={{ marginLeft: "10%" }}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={item.status === "1"}
                                                                                        onChange={(e) =>
                                                                                            this.handleStatusToggle(item.id, e.target.checked)
                                                                                        }
                                                                                    />
                                                                                    <span className="slider round"></span>
                                                                                </label>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        {/* TABLE 2: Pdf Category */}
                                                        <div className="sticky-table-container" style={{ marginTop: "20px" }}>
                                                            <h6 className="file-status-header">PDF Compression By Document Type</h6>

                                                            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Search Category..."
                                                                    value={this.state.deedSearch}
                                                                    onChange={(e) => this.setState({ deedSearch: e.target.value })}
                                                                    style={{
                                                                        width: "200px",
                                                                        padding: "6px",
                                                                        borderRadius: "4px",
                                                                        border: "1px solid #ccc"
                                                                    }}
                                                                />
                                                            </div>

                                                            <table className="table">
                                                                <thead className="sticky-table-header">
                                                                    <tr>
                                                                        <th scope="col">Sl.No</th>
                                                                        <th scope="col">Category</th>
                                                                        <th scope="col">Quality</th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    {deeds
                                                                        .filter(item =>
                                                                            item.name?.toLowerCase().includes(this.state.deedSearch.toLowerCase())
                                                                        )
                                                                        .map((item, index) => (
                                                                            <tr key={item.id}>
                                                                                <td className="indexInput text-center">{index + 1}</td>
                                                                                <td className="indexInput text-center">{item.name}</td>
                                                                                <td>{this.renderQualityOptions(item, "deed")}</td>
                                                                            </tr>
                                                                        ))}

                                                                    {deeds.filter(item =>
                                                                        item.name?.toLowerCase().includes(this.state.deedSearch.toLowerCase())
                                                                    ).length === 0 && (
                                                                            <tr>
                                                                                <td colSpan={3} className="text-center text-muted">
                                                                                    No matching records found
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        {/* TABLE 3: Ec Pdf Category */}
                                                        <div className="sticky-table-container" style={{ marginTop: "20px", height: 'auto' }}>
                                                            <h6 className="file-status-header">
                                                                PDF Compression By Ec Category
                                                            </h6>
                                                            <table className="table">
                                                                <thead className="sticky-table-header">
                                                                    <tr>
                                                                        <th scope="col">Sl.No</th>
                                                                        <th scope="col">Category</th>
                                                                        <th scope="col">Quality</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {pdfCategoryItems.map((item, index) => (
                                                                        <tr key={item.id}>
                                                                            <td className="indexInput text-center">{index + 1}</td>
                                                                            <td className="indexInput text-center">{item.name}</td>
                                                                            <td>{this.renderQualityOptions(item, "ec")}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* THIS FOR OUT REASON MODAL */}
                                    <div
                                        className="modal fade hide in"
                                        id="out_reason"
                                        data-backdrop="static"
                                        data-keyboard="false"
                                    >
                                        <div className="modal-dialog ">
                                            <div
                                                className="modal-content"
                                                style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                                            >
                                                <div
                                                    className="modal-body"
                                                    style={{ padding: "30px 23px 29px 24px" }}
                                                >
                                                    <h3 style={{ margin: "auto", fontSize: "17px" }}>
                                                        Please Select The Reason For To Close The File.No:
                                                        {localStorage.getItem("currentfileId")}
                                                    </h3>
                                                </div>
                                                <div
                                                    className="form-group"
                                                    style={{ width: "74%", margin: "auto" }}
                                                >
                                                    <select
                                                        className="custom-select"
                                                        name="outreason"
                                                        value={this.state.outreason}
                                                        onChange={(e) => this.onchangeReason(e)}
                                                        required
                                                        id="select1"
                                                        style={{ marginTop: "8px" }}
                                                    >
                                                        <option value="select">Select Your Reason</option>
                                                        <option value="Query Raised">Query Raised</option>
                                                        <option value=" Re-Query Raised"> Re-Query Raised</option>
                                                        <option value="Hold ">Hold </option>
                                                        <option value="Completed">Completed</option>
                                                        <option value="Other">Others</option>
                                                    </select>
                                                    {this.state.selectVal ? (
                                                        <p
                                                            style={{
                                                                color: "red",
                                                                textAlign: "center",
                                                                fontSize: "16px",
                                                            }}
                                                        >
                                                            Please Select Your Reason{" "}
                                                        </p>
                                                    ) : null}
                                                </div>
                                                <div className="modal-footer" style={{ marginTop: "27px" }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        disabled={this.state.isLoading}
                                                        onClick={this.outimeGet}
                                                        style={{ width: "76px", fontSize: "17px" }}
                                                    >
                                                        {" "}
                                                        {this.state.isLoading ? (
                                                            <i className="fa fa-spinner fa-spin"></i>
                                                        ) : (
                                                            "OK"
                                                        )}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline"
                                                        onClick={this.BacktoFile}
                                                        style={{
                                                            width: "107px",
                                                            fontSize: "14px",
                                                            border: "1px solid black",
                                                            height: "43px",
                                                        }}
                                                    >
                                                        {" "}
                                                        Back To File
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* OTHER REASON MODAL */}
                                    <div
                                        className="modal hide fade in"
                                        id="another-reason"
                                        data-backdrop="static"
                                        data-keyboard="false"
                                    >
                                        <div className="modal-dialog ">
                                            <div
                                                className="modal-content"
                                                style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                                            >
                                                <h5 style={{ marginTop: "31px", textAlign: "center" }}>
                                                    Please Type a Reason To Close The File.No:{" "}
                                                    {localStorage.getItem("currentfileId")}{" "}
                                                </h5>
                                                <div
                                                    className="modal-body"
                                                    style={{ padding: "30px 23px 29px 24px" }}
                                                >
                                                    {/* <div className="col-md-5"> */}
                                                    <div
                                                        className="form-group"
                                                        style={{ width: "98%", margin: "auto" }}
                                                    >
                                                        <textarea
                                                            className="form-control"
                                                            placeholder="Type Your Reason"
                                                            name="outreason"
                                                            onChange={this.onchange}
                                                        />
                                                        {this.state.selectVal ? (
                                                            <p
                                                                style={{
                                                                    color: "red",
                                                                    textAlign: "center",
                                                                    fontSize: "16px",
                                                                }}
                                                            >
                                                                Please Select Your Reason{" "}
                                                            </p>
                                                        ) : null}
                                                    </div>
                                                    {/* </div> */}
                                                </div>
                                                <div className="modal-footer">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={() => this.outimeGet()}
                                                        style={{ width: "76px", fontSize: "17px" }}
                                                        disabled={this.state.isLoading}
                                                    >
                                                        {" "}
                                                        {this.state.isLoading ? (
                                                            <i className="fa fa-spinner fa-spin"></i>
                                                        ) : (
                                                            "OK"
                                                        )}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline"
                                                        onClick={() => this.previousPop()}
                                                        // onClick={this.disableModalHandler}
                                                        style={{
                                                            width: "76px",
                                                            fontSize: "17px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {" "}
                                                        Back
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default PdfCompressManagement;